<template>
  <div class="modal fade" id="planModal" tabindex="-1">
    <div class="modal-dialog modal-xl">
      <div class="modal-content" :key="uniqueKey">

        <div class="modal-header">
          <h5 class="modal-title">
            {{ isEditMode ? 'Editar Plano' : 'Novo Plano' }}
          </h5>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>

        <div class="modal-body">
          <form @submit.prevent="submit">
            <div class="row">
              <div class="col-md-12">
                <label class="form-label">Plano</label>
                <input type="text" class="form-control form-control-solid"
                       required placeholder="Ex. Cartão premium" v-model="form.plan_name"/>
              </div>

              <div class="col-md-12">
                <label class="form-label">Descrição</label>
                <input type="text" class="form-control form-control-solid" v-model="form.plan_description" />
              </div>

              <div class="col-md-6">
                <label class="form-label">Valor: </label>
                <money3 required
                  class="form-control form-control-solid"
                  v-model="form.plan_base_price"
                  v-bind="config">
                </money3>
              </div>

              <div class="col-md-6">
                <label class="form-label">Valor por dependente</label>
                <money3
                  class="form-control form-control-solid"
                  v-model="form.plan_dependent_price"
                  v-bind="config">
                </money3>
              </div>

              <div class="col-md-6">
                <label class="form-label">Data de Início</label>
                <Calendar class="form-control form-control-sm"
                          required :min-date="new Date()" dateFormat="dd/mm/yy" v-model="form.plan_start_at"/>
              </div>

              <div class="col-md-6">
                <label class="form-label">Data de Fim</label>
                <Calendar class="form-control form-control-sm"
                          :min-date="new Date()" dateFormat="dd/mm/yy" v-model="form.plan_finish_at"/>
              </div>

              <div class="col-md-6">
                <label class="form-label">Nro. Máximo de dependentes</label>
                <input type="number" class="form-control form-control-solid" v-model="form.plan_max_dependents" />
              </div>

              <div class="col-md-6">
                <label class="form-label">Dependentes gratuitos</label>
                <input type="number" class="form-control form-control-solid" v-model="form.plan_free_dependents" min="0" />
              </div>

              <div class="col-md-6">
                <label class="form-label">Duração da assinatura</label>
                <div class="input-group mb-3">
                  <input type="number" class="form-control form-control-solid" required v-model="form.subscriber_duration" />
                  <div class="input-group-append">
                    <span class="input-group-text" id="basic-addon2">Meses</span>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <label class="form-label">Benefícios do Plano</label>
                <div class="mb-3">
                  <div class="row">
                    <div class="col-md-8">
                      <input type="text" class="form-control form-control-solid" 
                             v-model="newFeature" 
                             placeholder="Digite uma funcionalidade"
                             @keyup.enter="addFeature" />
                    </div>
                    <div class="col-md-4">
                      <button type="button" class="btn btn-primary" @click="addFeature">
                        Adicionar
                      </button>
                    </div>
                  </div>
                </div>
                <div v-if="form.plan_features && form.plan_features.length > 0" class="mt-2">
                  <div class="d-flex flex-wrap gap-2">
                    <span v-for="(feature, index) in form.plan_features" :key="index" 
                          class="badge bg-primary d-flex align-items-center">
                      {{ feature }}
                      <button type="button" class="btn-close btn-close-white ms-2" 
                              @click="removeFeature(index)" 
                              style="font-size: 0.7em;"></button>
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <label class="form-label">Imagem de fundo do cartão</label>
                <input type="file" class="form-control form-control-solid" 
                       accept="image/*"
                       @change="handleImageUpload" />
                <small class="form-text text-muted">Esta imagem será usada como fundo no cartão do plano.</small>
                <div v-if="imagePreview" class="mt-2">
                  <img :src="imagePreview" alt="Preview" style="max-width: 200px; max-height: 150px; border-radius: 4px;" />
                </div>
              </div>

              <div class="col-md-12 mt-3">
                <label class="form-label">Modelo de Contrato</label>
                <select class="form-select form-select-solid" v-model="selectedContractTemplateId">
                  <option :value="null">Nenhum</option>
                  <option v-for="template in contractTemplates" :key="template.id_contract_template" 
                          :value="template.id_contract_template">
                    {{ template.template_name }}
                  </option>
                </select>
                <small class="form-text text-muted">
                  O contrato será gerado automaticamente quando um assinante se inscrever neste plano.
                </small>
              </div>

              <div class="col-md-4 mt-3">
                <label class="form-label">Plano empresarial?</label>
                <div class="row form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="plan_company"
                         v-model="form.plan_company">
                </div>
              </div>

              <div class="col-md-4 mt-3">
                <label class="form-label">Ativo?</label>
                <div class="row form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="plan_active"
                         v-model="form.plan_active">
                </div>
              </div>

            </div>

            <div class="modal-footer mt-3">
              <button type="button" class="btn btn-secondary" @click="closeModal">Cancelar</button>
              <button type="submit" class="btn btn-primary">
                {{ isEditMode ? 'Atualizar' : 'Salvar' }}
              </button>
            </div>
          </form>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import http from "@/helpers/http";
import Modal from "@/helpers/modal";
import Calendar from "primevue/calendar";
import {mask} from "vue-the-mask";
import {Money3} from "v-money3";
import Alert from "@/helpers/alert";
import str from "@/helpers/str";

export default {
  name: "PlanModal",
  props: ['plan'],
  components: {
    Money3,
    Calendar,
  },
  directives: {
    mask
  },
  data() {
    return {
      planLocal: null,
      config: {
        masked: false,
        prefix: 'R$ ',
        suffix: '',
        thousands: '.',
        decimal: ',',
        precision: 2,
        disableNegative: true,
        disabled: false,
        min: null,
        max: null,
        allowBlank: true,
        minimumNumberOfCharacters: 0,
        shouldRound: false,
        focusOnRight: false,
      },
      form: {
        plan_name: null,
        plan_description: null,
        plan_base_price: 0,
        plan_dependent_price: 0,
        plan_active: true,
        plan_company: false,
        plan_start_at: null,
        plan_finish_at: null,
        plan_max_dependents: null,
        plan_free_dependents: null,
        subscriber_duration: null,
        plan_card_image: null,
        plan_features: [],
      },
      imagePreview: null,
      selectedPlan: null,
      planId: null,
      uniqueKey: this.date().unix().toString(),
      newFeature: '',
      contractTemplates: [],
      selectedContractTemplateId: null,
    };
  },
  watch: {
    plan: {
      immediate: true,
      handler(newValue) {
        this.planLocal = newValue;
        this.populateModal();
        this.uniqueKey = this.date().unix().toString();
      }
    }
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    isEditMode() {
      return this.plan !== null;
    }
  },
  mounted() {
    this.uniqueKey = this.date().unix().toString();
    this.loadContractTemplates();
  },
  methods: {
    date: moment,
    populateModal() {
      if (!this.planLocal) {
        this.resetModal();
        if (this.place?.id_place) {
          this.loadContractTemplates();
        }
        return;
      }

      this.planId = this.planLocal.id_plan;
      if (!this.planId) {
        this.resetModal();
        return;
      }

      this.form = {
        plan_name: this.planLocal.plan_name,
        plan_description: this.planLocal.plan_description,
        plan_base_price: this.planLocal.plan_base_price,
        plan_dependent_price: this.planLocal.plan_dependent_price,
        plan_active: this.planLocal.plan_active,
        plan_company: this.planLocal.plan_company || false,
        plan_start_at: this.date(this.planLocal.plan_start_at).format('DD/MM/YYYY'),
        plan_finish_at: this.planLocal.plan_finish_at != null ? this.date(this.planLocal.plan_finish_at).format('DD/MM/YYYY') : null,
        plan_max_dependents: this.planLocal.plan_max_dependents,
        plan_free_dependents: this.planLocal.plan_free_dependents,
        subscriber_duration: this.planLocal.subscriber_duration,
        plan_card_image: null,
        plan_features: this.planLocal.plan_features || [],
      };

      // Se já existe uma imagem, mostrar preview
      if (this.planLocal.plan_card_image) {
        this.imagePreview = str.url(this.planLocal.plan_card_image);
      }

      // Verificar se existe um template vinculado a este plano
      this.loadContractTemplates();
      this.$nextTick(() => {
        // Verificar se o plano já tem um template de contrato vinculado
        if (this.planLocal.contract_template) {
          this.selectedContractTemplateId = this.planLocal.contract_template.id_contract_template;
        }
      });
    },
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.form.plan_card_image = file;
        
        // Criar preview da imagem
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imagePreview = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    async submit() {
      let response;
      if (this.isEditMode) {
        response = await this.updatePlan();
      } else {
        response = await this.createPlan();
      }

      // Para planos recém-criados, definir o planId
      if (response?.data?.id_plan) {
        this.planId = response.data.id_plan;
      }

      Alert.success('Plano salvo com sucesso.');
      this.$emit('planSaved');
      this.closeModal();
    },
    async createPlan() {
      const formData = this.prepareFormData();
      return http.post(`/places/${this.place.id_place}/plans`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    },
    async updatePlan() {
      const formData = this.prepareFormData();
      
      formData.append('_method', 'PUT');
      
      return http.post(`/places/${this.place.id_place}/plans/${this.planId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    },
    prepareFormData() {
      const formData = new FormData();
      
      Object.keys(this.form).forEach(key => {
        if (this.form[key] !== null && this.form[key] !== undefined) {
          
          if (key === 'plan_start_at' || key === 'plan_finish_at') {
            if (this.form[key] instanceof Date) {
              formData.append(key, this.date(this.form[key]).format('YYYY-MM-DD'));
            } else if (typeof this.form[key] === 'string' && this.form[key]) {
              
              const dateObj = this.date(this.form[key], 'DD/MM/YYYY');
              if (dateObj.isValid()) {
                formData.append(key, dateObj.format('YYYY-MM-DD'));
              }
            }
          } else if (typeof this.form[key] === 'boolean')
          {
            formData.append(key, this.form[key] ? '1' : '0');
          } else {
            formData.append(key, this.form[key]);
          }
        }
      });

      formData.append('id_contract_template', this.selectedContractTemplateId ?? '');
      return formData;
    },
    closeModal() {
      Modal.toggle('#planModal');
      this.$emit('onClose');
    },
    resetModal() {
      this.form = {
        plan_name: null,
        plan_description: null,
        plan_base_price: 0,
        plan_dependent_price: 0,
        plan_active: true,
        plan_company: false,
        plan_start_at: null,
        plan_finish_at: null,
        plan_max_dependents: null,
        plan_free_dependents: null,
        subscriber_duration: null,
        plan_card_image: null,
        plan_features: [],
      };

      this.imagePreview = null;
      this.planId = null;
      this.selectedPlan = null;
      this.newFeature = '';
      this.selectedContractTemplateId = null;
    },
    addFeature() {
      if (this.newFeature && this.newFeature.trim() !== '') {
        this.form.plan_features.push(this.newFeature.trim());
        this.newFeature = '';
      }
    },
    removeFeature(index) {
      this.form.plan_features.splice(index, 1);
    },
    loadContractTemplates() {
      if (!this.place?.id_place) return;
      http.get(`/places/${this.place.id_place}/contract-templates`, {
        params: { per_page: 100 }
      }).then((response) => {
        const raw = response.data?.data ?? response.data;
        this.contractTemplates = Array.isArray(raw) ? raw : [];
      }).catch(() => {
        this.contractTemplates = [];
      });
    },
  }
}
</script>